/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Victor Manuel Calle Londoño                                ║
║ victor.calle@est.iudigital.edu.co                          ║
╚════════════════════════════════════════════════════════════╝
*/
import DataTable from "examples/Tables/DataTable";
import MDInput from "components/MDInput";
import verDetallesImg from "assets/images/ver_detalles.svg";
import React, { useState, useEffect, useRef } from "react";
import { useAsyncDebounce } from "react-table";
import MDBadge from "components/MDBadge";
import DownloadIcon from "@mui/icons-material/Download";

import {
  Icon,
  Checkbox,
  FormControl,
  Hidden,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  CircularProgress,
  FormHelperText,
  Divider,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDPagination from "components/MDPagination";
import MDTypography from "components/MDTypography";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import { date } from "yup";
import { position } from "stylis";
import { red } from "@mui/material/colors";
import MDAlert from "components/Alert";
import usePermission from "hooks/usePermission";
export default function ListCarnets({
  listCarnets,
  dataTypeCard,
  error,
  pageIndexAndPageSize,
  entriesStart,
  entriesEnd,
  totalData,
  paginaSize,
  currentPage,
  totalPages,
  handlePageChange,
  handleOpenToModal,
  handleSelect,
  getSelectableRows,
  handleSelectAll,
  selected,
  handleOpenValidity,
  handleSendCard,
  rows,
  handleRequestDownload,
  handleSendCarnetAccumulated,
  handleOpenModalAddInvitadoAndCarnet,
}) {
  const [isAlert, setIsAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("fail");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => setOpenModal(false);
  // Enviar correos para todos los usuarios
  const handleSendMailForAll = async () => {
    try {
      const response = await handleSendCard("false");
      if (response && response.status == 200) {
        setAlertType("success");
        setAlertMessage("Operación completada con éxito.");
        setIsAlert(true);
      } else {
        setAlertType("fail");
        setAlertMessage(`${response.message}`);
        setIsAlert(true);
      }
    } catch (error) {
      setAlertType("fail");
      setAlertMessage(`${error.message}`);
      setIsAlert(true);
    }
  };

  // Enviar correos para  usuarios no notificados
  const handleSendMail = async () => {
    try {
      const response = await handleSendCard("true");
      if (response && response.status == 200) {
        // Verificar si result.payload existe y es un string
        const message =
          typeof response.data?.payload === "string"
            ? response.data.payload
            : "Carnets enviados correctamente";

        // Determinar el tipo de alerta basado en el contenido del mensaje
        if (message.includes("no pudieron ser enviados")) {
          // Si el mensaje indica que hubo carnets que no se enviaron, usar warning
          setAlertType("warning");
          setAlertMessage(message);
        } else {
          // Si todos los carnets se enviaron, usar success
          setAlertType("success");
          setAlertMessage(message);
        }
        setIsAlert(true);
      } else {
        setAlertType("fail");
        setAlertMessage(`${response.message}`);
        setIsAlert(true);
      }
    } catch (error) {
      setAlertType("fail");
      setAlertMessage(`${error.message}`);
      setIsAlert(true);
    }
  };

  const [actions, setActions] = React.useState("");

  const handleChange = (event) => {
    setActions(event.target.value);
  };

  const executeFunction = () => {
    if (actions === 20) {
      handleSendMail();
    } else if (actions === 30) {
      handleOpenValidity();
    } else if (actions === 40) {
      handleSendCarnetAccumulated();
    }
  };

  const canValidityCarnet = usePermission("Card.edit.validity");
  const canSendEmailCarnet = usePermission("Card.send");
  const canListCardPerFile = usePermission("Card.byFilterPerFile");
  const cantAddUserAndCarnet = usePermission("Card.createUserCardSource");
  return (
    <>
      {/* {selected.length > 0 && (
        <div>
          {canValidityCarnet && (
            <MDButton
              onClick={handleOpenValidity}
              style={{ left: "20px", marginTop: "10px" }}
              variant="outlined"
              color="info"
            >
              Cambiar vigencia de carnets
            </MDButton>
          )}
        </div>
      )} */}
      {isAlert && (
        <MDAlert
          isAlert={isAlert}
          setIsAlert={setIsAlert}
          typeAlert={alertType}
          message={alertMessage}
        />
      )}
      <br />
      <Divider></Divider>
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px", // Espaciado entre elementos
        }}
      >
        <FormControl style={{ left: "20px" }} variant="standard" sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-label">Acción por...</InputLabel>
          <Select
            style={{ width: "auto" }}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={actions}
            label="Filtrado por..."
            onChange={handleChange}
          >
            <MenuItem value="">NINGUNO</MenuItem>
            <MenuItem value={20}>Enviar carnet a usuarios no notificados</MenuItem>
            <MenuItem value={30}>Cambiar vigencia de carnets</MenuItem>
            <MenuItem value={40}>Enviar carnet a usuarios seleccionados</MenuItem>
          </Select>
        </FormControl>
        <MDButton
          style={{ left: "20px" }}
          variant="gradient"
          size="small"
          color="info"
          onClick={executeFunction}
        >
          Enviar
        </MDButton>
        {/* Botón "Agregar nuevo invitado" con diseño responsivo */}
        {cantAddUserAndCarnet && (
          <MDButton
            variant="gradient"
            color="info"
            style={{ left: "20px" }}
            size="small"
            onClick={handleOpenModalAddInvitadoAndCarnet}
          >
            Agregar carnet
          </MDButton>
        )}
      </div>
      {canListCardPerFile && (
        <>
          <DataTable
            table={{
              columns: [
                {
                  Header: "Checkbox",
                  id: "checkbox",
                  accessor: (row) => {
                    // Verificar si el carnet está expirado
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const expiryDate = new Date(row.expired_in);
                    // const isExpired =
                    //   expiryDate < today || row.status?.props?.badgeContent === "Inactivo";
                    const isExpired = row.status?.props?.badgeContent === "Inactivo";
                    return (
                      <Checkbox
                        checked={selected.indexOf(row.id) !== -1}
                        onChange={() => handleSelect(row.id)}
                        disabled={isExpired}
                        sx={{
                          opacity: isExpired ? 0.5 : 1,
                          cursor: isExpired ? "not-allowed" : "pointer",
                          "&.Mui-disabled": {
                            color: "gray",
                          },
                        }}
                        title={isExpired ? "Carnet expirado o inactivo" : ""}
                      />
                    );
                  },
                  width: "0px",
                  Header: () => (
                    <Checkbox
                      indeterminate={
                        selected.length > 0 && selected.length < getSelectableRows().length
                      }
                      checked={
                        getSelectableRows().length > 0 &&
                        selected.length === getSelectableRows().length
                      }
                      onChange={handleSelectAll}
                    />
                  ),
                  disableSortBy: true,
                },
                { Header: "Nombre completo", accessor: "name", sortable: true },
                { Header: "Documento de Identificación", accessor: "dni", sortable: true },
                { Header: "Correo electrónico", accessor: "email", sortable: true },
                { Header: "Tipo carnet", accessor: "card_type_name", sortable: true },
                { Header: "Fecha creado", accessor: "created", sortable: true },
                { Header: "Fecha Vigencia", accessor: "expired_in", sortable: true },
                { Header: "Estado", accessor: "status", sortable: true },
                { Header: "Tipo sangre", accessor: "blood_type", sortable: true },
                { Header: "Ingresado", accessor: "joined", sortable: true },
                { Header: "Notificado", accessor: "notified", sortable: true },
                { Header: "Descargado", accessor: "latest_link_status", sortable: true },
                {
                  Header: "Fecha notificación",
                  accessor: "latest_link_created_at",
                  sortable: true,
                },
                {
                  Header: "Acciones",
                  accessor: "actions",
                  disableSortBy: true, // Deshabilitar ordenación para la columna de acciones
                },
              ],
              rows: rows,
            }}
            pageIndexAndPageSize={pageIndexAndPageSize}
            canSearch={false}
            entriesPerPage={false}
            showTotalEntries={false}
            // Propiedades adicionales para la ordenación
            defaultSortDes={true} // Orden ascendente por defecto
          />

          {error ? (
            <MDBox style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <MDTypography
                style={{ left: "20px", fontSize: "20px" }}
                variant="button"
                color="secondary"
                fontWeight="regular"
              >
                {error}
              </MDTypography>
            </MDBox>
          ) : listCarnets?.length === 0 || !listCarnets ? (
            <MDBox style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <MDTypography
                style={{ left: "20px", fontSize: "20px" }}
                variant="button"
                color="secondary"
                fontWeight="regular"
              >
                No hay datos
              </MDTypography>
            </MDBox>
          ) : (
            <>
              <MDBox style={{ marginLeft: "20px" }} mb={{ xs: 3, sm: 0 }}>
                <MDTypography
                  style={{ left: "20px" }}
                  variant="button"
                  color="secondary"
                  fontWeight="regular"
                >
                  Mostrando resultados {entriesStart} - {entriesEnd} de un total de {totalData}
                </MDTypography>
              </MDBox>
              <Stack style={{ marginLeft: "20px", marginBottom: "10px" }} spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                ></Pagination>
              </Stack>{" "}
            </>
          )}
        </>
      )}
    </>
  );
}
